import React from "react";
import { DASHBOARD_FIELD_LABEL_CLASS } from "../InputField/dashboardFieldClassNames";

/**
 * Dashboard field label — 11px lg · 12px xl+.
 */
const DashboardFieldLabel = ({ as: Tag = "label", htmlFor, children, className = "", ...rest }) => (
  <Tag
    htmlFor={htmlFor}
    className={`${DASHBOARD_FIELD_LABEL_CLASS} ${className}`.trim()}
    {...rest}
  >
    {children}
  </Tag>
);

export default DashboardFieldLabel;
